import { Package } from 'lucide-react';

const CATEGORY_IMAGES = {
  'Rice': 'https://images.unsplash.com/photo-1586201375761-83865001e31c?crop=entropy&cs=srgb&fm=jpg&q=85',
  'Ghee': 'https://images.unsplash.com/photo-1631452180519-c014fe946bc7?crop=entropy&cs=srgb&fm=jpg&q=85',
  'Sugar': 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62?crop=entropy&cs=srgb&fm=jpg&q=85',
  'Flour': 'https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?crop=entropy&cs=srgb&fm=jpg&q=85',
  'Peanuts': 'https://images.pexels.com/photos/4202964/pexels-photo-4202964.jpeg',
  'Chana': 'https://images.unsplash.com/photo-1705845580041-f04ad853617f?crop=entropy&cs=srgb&fm=jpg&q=85',
  'Gajaks': 'https://images.unsplash.com/photo-1655542049722-395a243e12b7?crop=entropy&cs=srgb&fm=jpg&q=85',
  'Chikki': 'https://images.unsplash.com/photo-1655542049722-395a243e12b7?crop=entropy&cs=srgb&fm=jpg&q=85',
  'Namkeens': 'https://images.unsplash.com/photo-1601050690597-df0568f70950?crop=entropy&cs=srgb&fm=jpg&q=85',
  'default': 'https://images.unsplash.com/photo-1606824722920-4c652a70f348?crop=entropy&cs=srgb&fm=jpg&q=85'
};

function CategoryRow({ category, selected, onSelect }) {
  const image = category.image || CATEGORY_IMAGES[category.name] || CATEGORY_IMAGES.default;
  return (
    <button
      data-testid={`category-item-${category.id}`}
      onClick={() => onSelect(category.id)}
      className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-left transition-all border ${
        selected
          ? 'bg-[#01195d] border-[#01195d] text-white shadow-sm'
          : 'bg-white border-slate-200 hover:border-[#01195d]/40 hover:bg-slate-50 text-slate-700'
      }`}
    >
      <img
        src={image}
        alt=""
        className="w-10 h-10 rounded-md object-cover flex-shrink-0 bg-slate-100"
      />
      <div className="flex-1 min-w-0">
        <p className={`text-sm font-semibold truncate ${selected ? 'text-white' : 'text-slate-800'}`}>
          {category.name}
        </p>
        <p className={`text-xs ${selected ? 'text-white/70' : 'text-slate-500'}`}>
          {category.product_count} {category.product_count === 1 ? 'product' : 'products'}
        </p>
      </div>
    </button>
  );
}

export function CategorySidebar({ categories, selectedId, onSelect }) {
  return (
    <aside
      data-testid="category-sidebar"
      className="lg:sticky lg:top-24 lg:self-start"
    >
      <div className="lg:block hidden">
        <div className="flex items-center gap-2 mb-3 px-1">
          <Package className="w-4 h-4 text-[#01195d]" />
          <h3 className="text-xs font-bold text-slate-500 tracking-wider uppercase">Categories</h3>
        </div>
        <div className="space-y-1.5">
          {categories.map(cat => (
            <CategoryRow
              key={cat.id}
              category={cat}
              selected={selectedId === cat.id}
              onSelect={onSelect}
            />
          ))}
        </div>
      </div>

      {/* Mobile: horizontal scroll pills */}
      <div className="lg:hidden -mx-4 px-4 pb-2 overflow-x-auto">
        <div className="flex gap-2 pb-1">
          {categories.map(cat => (
            <button
              key={cat.id}
              data-testid={`category-pill-${cat.id}`}
              onClick={() => onSelect(cat.id)}
              className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-semibold border transition-all whitespace-nowrap ${
                selectedId === cat.id
                  ? 'bg-[#01195d] border-[#01195d] text-white'
                  : 'bg-white border-slate-200 text-slate-700 hover:border-[#01195d]/40'
              }`}
            >
              {cat.name} <span className="opacity-60">· {cat.product_count}</span>
            </button>
          ))}
        </div>
      </div>
    </aside>
  );
}

export default CategorySidebar;
